import {
  BillingReadinessDetail,
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';
import { useQuery } from 'react-query';
import billingReadinessService from '../services/billingReadiness.service';

const useBillingReadiness = (window: BillingReadinessWindow, enabled = true) =>
  useQuery<BillingReadinessResponse>(
    ['billing-readiness', window],
    () => billingReadinessService.list(window),
    // Rolls up at most hourly (proc interval), so a 5-min staleTime avoids a
    // refetch on every modal open/close without showing meaningfully stale data.
    { refetchOnWindowFocus: false, enabled, staleTime: 5 * 60 * 1000 }
  );

export const useBillingReadinessDetail = (
  clinicId: number | null,
  window: BillingReadinessWindow
) =>
  useQuery<BillingReadinessDetail>(
    ['billing-readiness-detail', clinicId, window],
    () => billingReadinessService.detail(clinicId as number, window),
    { refetchOnWindowFocus: false, enabled: clinicId != null, staleTime: 5 * 60 * 1000 }
  );

export default useBillingReadiness;
